'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('hamburgers/dist/hamburgers.min.css');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "v-burger",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "boring"
    },
    burgerStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ariaLabel: {
      type: String,
      default: "Menu"
    },
    ariaControls: {
      type: String,
      default: "navigation"
    },
    tabIndex: {
      type: Number,
      default: 0
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "hamburger",
    class: ["hamburger--" + _vm.type, {
      'is-active': _vm.active
    }],
    style: _vm.burgerStyle,
    attrs: {
      "aria-label": _vm.ariaLabel,
      "aria-controls": _vm.ariaControls,
      "aria-expanded": _vm.active,
      "tabindex": _vm.tabIndex,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('updated', !_vm.active);
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._t("label")], 2);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "hamburger-box"
  }, [_c('span', {
    staticClass: "hamburger-inner"
  })]);
}];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "Burger.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */


var VBurger = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var VBurgerPlugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name || VBurger.name;
    Vue.component(name, VBurger);
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VBurgerPlugin);
}

exports.VBurger = VBurger;
exports.VBurgerPlugin = VBurgerPlugin;
exports.default = VBurgerPlugin;
